module.exports = __webpack_public_path__ + "img/Group11.e5d27eef.png";